import { schema } from "normalizr";

const farbeSchema = new schema.Entity("farbe", {}, { idAttribute: "id" });

export { farbeSchema };
